/**
 * Generates optimized Open Graph image URLs for social media sharing
 * @param {string} type - Type of content: 'creation', 'news', 'profile', or 'default'
 * @param {Object} data - Content data object
 * @param {string} data.title - Title of the content
 * @param {string} data.author - Author name or username
 * @param {string} data.image - Original image URL
 * @param {string} data.description - Description text
 * @param {string} data.id - Content ID (optional)
 * @returns {string} Optimized OG image URL
 */
export function getOGImageUrl(type, data = {}) {
  const baseUrl = typeof window !== 'undefined' 
    ? window.location.origin 
    : process.env.VITE_SUPABASE_REDIRECT_URL || 'https://app.hyk.media';

  const { title = '', author = '', image = '', description = '', id = '' } = data;

  // Build query parameters
  const params = new URLSearchParams({
    type: type || 'default',
  });

  if (title) params.append('title', title);
  if (author) params.append('author', author);
  if (image) params.append('image', image);
  if (description) params.append('description', description);
  if (id) params.append('id', id);

  return `${baseUrl}/api/og-image?${params.toString()}`;
}

/**
 * Gets the fallback OG image URL (HYK logo)
 * @returns {string} Fallback OG image URL
 */
export function getFallbackOGImageUrl() {
  const baseUrl = typeof window !== 'undefined' 
    ? window.location.origin 
    : process.env.VITE_SUPABASE_REDIRECT_URL || 'https://app.hyk.media';
  
  return `${baseUrl}/api/og-image?type=default&title=HYK%20Media`;
}

